import React, { ButtonHTMLAttributes } from 'react';
import classNames from 'classnames';
import { useAccordionContext } from './AccordionContext';

export interface AccordionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * The Accordion Content's id that this heading controls
   */
  controls: string;
}

const AccordionButton = ({ controls, children, className, ...rest }: AccordionButtonProps): JSX.Element => {
  const { toggle, isOpen } = useAccordionContext();
  const handleClick = (): void => toggle(controls);
  const expanded = isOpen(controls);

  return (
    <button
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      type="button"
      className={classNames(className, 'usa-accordion__button')}
      aria-expanded={expanded}
      aria-controls={controls}
      onClick={handleClick}
    >
      {children}
    </button>
  );
};

export default AccordionButton;
